import * as React from 'react';
import { v4 as uuidv4 } from 'uuid';

import AnnouncementItem from './AnnouncementItem/AnnouncementItem';
import Loading from '../../react-common/Loading';

type AnnouncementListProps = {
  announcements: object[];
  type: 'draft' | 'sent' | 'scheduled';
  isLoading: boolean;
  deleteAnnouncement: (
    announcementId: string,
  ) => (event: React.MouseEvent) => Promise<void>;
};

const AnnouncementList = (props: AnnouncementListProps) => {
  const { announcements, type, isLoading, deleteAnnouncement } = props;
  return (
    <section className="announcement-list">
      {isLoading && (
        <div className="loading-container">
          <Loading size={'fa-3x'} />
        </div>
      )}
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {!announcements.length && !isLoading && (
          <div>No Announcements Found</div>
        )}
        {announcements.map(announcement => (
          <AnnouncementItem
            deleteAnnouncement={deleteAnnouncement}
            key={uuidv4()}
            type={type}
            announcement={announcement}
          />
        ))}
      </div>
    </section>
  );
};

export default AnnouncementList;
